import { useEffect, useState } from 'react';
import { useFileUpload } from '@/hooks';
import { useCompressImageMutation } from '@/store/api';

export function useUploadImage() {
	const [compressedImgData, setCompressedImgData] = useState(null);
	const [tagName, setTagName] = useState(null);
	const {
		startUpload,
		loading: uploadLoading,
		fileId: imageId,
		fileUrl: imageUrl,
		destination,
	} = useFileUpload();
	const [compressImage] = useCompressImageMutation();

	useEffect(() => {
		(async () => {
			if (!destination || !imageId) {
				return;
			}

			const urls = await compressImage({ imageId, destination });

			if (urls?.data) {
				setCompressedImgData({ ...urls.data, compressedTagName: tagName });
			}
		})();
	}, [destination, imageId, compressImage, tagName]);

	const UploadImage = async (file: any, destination: any, tag: any) => {
		if (tag) {
			setTagName(tag);
		}
		await startUpload(file, destination, true);
	};

	return { UploadImage, uploadLoading, imageId, imageUrl, compressedImgData };
}
